(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["list-filter"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('age-range-slider')) {
    customElements.define(
      'age-range-slider',
      class extends HTMLElement {

        connectedCallback() {
          this.minEl = this.querySelector('[data-min]');
          this.maxEl = this.querySelector('[data-max]');
          this.rangeEl = this.querySelector('[data-range]');
          this.labelEl = this.querySelector('[data-label]');

          if (!this.minEl || !this.maxEl) return;

          this.minEl.addEventListener('input', () => {
            this.update();
          });

          this.maxEl.addEventListener('input', () => {
            this.update();
          });

          this.minEl.addEventListener('change', () => {
            this.applyFilter();
          });

          this.maxEl.addEventListener('change', () => {
            this.applyFilter();
          });

          this.sync();
        }

        getInputs() {
          const component = this.closest('facet-inputs-component');

          if (!component) return [];

          return [
            ...component.querySelectorAll(
              '.age-slider-source input[type="checkbox"]'
            )
          ];
        }

        sync() {
          const inputs = this.getInputs();

          if (!inputs.length) return;

          const checked = inputs
            .map((input, index) => input.checked ? index : -1)
            .filter(index => index !== -1);

          const last = inputs.length - 1;

          if (checked.length) {
            this.minEl.value = Math.min(...checked);
            this.maxEl.value = Math.max(...checked);
          } else {
            this.minEl.value = 0;
            this.maxEl.value = last;
          }

          this.update();
        }

        update() {
          const inputs = this.getInputs();

          if (!inputs.length) return;

          const last = inputs.length - 1;

          let min = Number(this.minEl.value);
          let max = Number(this.maxEl.value);

          if (min > max) {
            if (document.activeElement === this.minEl) {
              min = max;
              this.minEl.value = min;
            } else {
              max = min;
              this.maxEl.value = max;
            }
          }

          min = Math.max(0, Math.min(min, last));
          max = Math.max(0, Math.min(max, last));

          this.minEl.value = min;
          this.maxEl.value = max;

          if (last > 0) {
            this.rangeEl.style.left =
              (min / last) * 100 + '%';

            this.rangeEl.style.width =
              ((max - min) / last) * 100 + '%';
          }

          const getLabel = (index) => {
            const input = inputs[index];

            if (!input) return '';

            return (
              input.getAttribute('aria-label') ||
              input.value
            );
          };

          this.labelEl.textContent =
            getLabel(min) + ' – ' + getLabel(max);
        }

        applyFilter() {
          const inputs = this.getInputs();

          if (!inputs.length) return;

          let min = Number(this.minEl.value);
          let max = Number(this.maxEl.value);

          const last = inputs.length - 1;

          if (min > max) {
            [min, max] = [max, min];

            this.minEl.value = min;
            this.maxEl.value = max;
          }

          /*
           * Update the real Shopify filter checkboxes.
           */
          inputs.forEach((input, index) => {
            input.disabled = false;

            input.checked =
              min !== 0 ||
              max !== last
                ? index >= min && index <= max
                : false;
          });

          this.update();

          /*
           * Build the Shopify filter URL directly.
           * This avoids the mobile facet event problem.
           */
          const form = this.closest('form');

          if (!form) {
            console.warn('Age slider: filter form not found');
            return;
          }

          const params = new URLSearchParams();

          /*
           * Collect every currently selected filter.
           */
          const formData = new FormData(form);

          for (const [key, value] of formData.entries()) {
            if (!value) continue;

            params.append(key, value);
          }

          /*
           * Remove pagination after changing filters.
           */
          params.delete('page');

          /*
           * Build final URL.
           */
          const action = form.getAttribute('action') || window.location.pathname;

          const queryString = params.toString();

          const url =
            action +
            (queryString ? '?' + queryString : '');

          /*
           * Navigate to the filtered collection.
           *
           * This works on both desktop and mobile because
           * we don't depend on the facet component's
           * JavaScript event handler.
           */
          window.location.href = url;
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["price-filter"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('dual-range-slider')) {
    customElements.define(
      'dual-range-slider',
      class extends HTMLElement {
        connectedCallback() {
          // wait a frame so child inputs exist even when parsed after the element
          requestAnimationFrame(() => this.init());
        }

        init() {
          if (this.ready) return;
          this.lo = this.querySelector('[data-lo]');
          this.hi = this.querySelector('[data-hi]');
          this.fill = this.querySelector('[data-fill]');
          this.readout = this.querySelector('[data-readout]');
          const facet = this.closest('price-facet-component');
          if (!this.lo || !this.hi || !facet) return;

          this.min = +this.dataset.min;
          this.max = +this.dataset.max;
          this.minInput = facet.querySelector('[ref="minInput"]');
          this.maxInput = facet.querySelector('[ref="maxInput"]');
          if (!this.minInput || !this.maxInput) return;
          this.ready = true;

          [this.lo, this.hi].forEach((el) => {
            el.addEventListener('input', () => this.onSlide(el));
            el.addEventListener('change', (e) => {
              e.stopPropagation();
              this.commit(el);
            });
          });

          // typing in the boxes moves the sliders
          [this.minInput, this.maxInput].forEach((inp) =>
            inp.addEventListener('input', () => this.syncFromInputs())
          );

          this.render();
        }

        num(v, fallback) {
          const n = parseFloat(String(v).replace(/[^0-9.]/g, ''));
          return Number.isNaN(n) ? fallback : n;
        }

        syncFromInputs() {
          this.lo.value = this.num(this.minInput.value, this.min);
          this.hi.value = this.num(this.maxInput.value, this.max);
          this.render();
        }

        onSlide(el) {
          const lo = +this.lo.value;
          const hi = +this.hi.value;
          if (lo > hi) {
            if (el === this.lo) this.lo.value = hi;
            else this.hi.value = lo;
          }
          // live update of the text boxes (empty = default, so no URL param)
          this.minInput.value = +this.lo.value <= this.min ? '' : this.lo.value;
          this.maxInput.value = +this.hi.value >= this.max ? '' : this.hi.value;
          this.render();
        }

        commit(el) {
          const input = el === this.lo ? this.minInput : this.maxInput;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }

        render() {
          const lo = +this.lo.value;
          const hi = +this.hi.value;
          const span = this.max - this.min || 1;
          this.fill.style.insetInlineStart = ((lo - this.min) / span) * 100 + '%';
          this.fill.style.width = ((hi - lo) / span) * 100 + '%';
          // keep a thumb grabbable when both sit at the far end
          this.lo.style.zIndex = lo >= this.max ? 2 : 1;
          if (this.readout) {
            const sym = this.readout.dataset.symbol || '';
            this.readout.textContent = `${sym}${lo.toLocaleString()} – ${sym}${hi.toLocaleString()}`;
          }
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
